var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1324,
    height: 555,
    viewBox: "0 0 1324 555",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1244 40H643C309.972 40 40 270.505 40 554.848",
    stroke: "#F9F9F9",
    strokeWidth: 80
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1244,
    width: 80,
    height: 80,
    fill: "#F70303"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/About.a4014c20464845c7947e4aa91cf7da44.svg";
export { ForwardRef as ReactComponent };